// extracted by mini-css-extract-plugin
export var infoItem = "_sj-2";
export var title = "_sj-0";
export var value = "_sj-1";